import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
interface HomePageProps {
  isDark: boolean;
}
export function HomePage({
  isDark
}: HomePageProps) {
  return <main data-id="element-185">
      <HeroSection isDark={isDark} data-id="element-186" />
      <ServicesSection data-id="element-187" />
      <HowItWorksSection data-id="element-188" />
      <AboutSection data-id="element-189" />
      <ContactSection data-id="element-190" />
    </main>;
}